import { ConfirmModal } from 'ui/modal';
import { BUTTON_VARIANTS } from 'ui/button';

type DeleteCatalogModalProps = {
  /* Name of the catalog to be deleted */
  name: string;
  /* Flag that tells if delete model is open */
  isOpen: boolean;
  /* Handles deletion if user confirmed it on modal */
  onDelete: () => void;
  /* Closes modal */
  closeModal: () => void;
};

export const DeleteCatalogModal = ({
  name,
  isOpen,
  closeModal,
  onDelete,
}: DeleteCatalogModalProps) => {
  return isOpen ? (
    <ConfirmModal
      bodyContent="Are you sure?"
      cancelLabel="No, cancel"
      confirmButtonContent="Yes, delete"
      confirmButtonVariant={BUTTON_VARIANTS.DESTRUCTIVE}
      data-test="DeleteCatalogModal"
      headerContent={`Delete ${name}`}
      id="deleteCatalogModal"
      isModalOpen={isOpen}
      onClose={closeModal}
      onConfirm={onDelete}
    />
  ) : null;
};
